import { Component, Input } from '@angular/core';
import { StepsInterface } from '../../../../../utils/models/common.interface';

@Component({
  selector: 'steps-induxtry',
  templateUrl: './steps.component.html',
  styleUrls: ['./steps.component.scss']
})
export class StepsComponent {
  @Input() icon = 'circle_information'
  @Input() steps: StepsInterface[] = [];

  returnIndexActive(): number {
    return this.steps.findIndex(res => res.state === 'ongoing');
  }
}
